import React from "react";
import { cn } from "@/utils/utils";

const MessageRoundedIcon = ({ className }: { className?: string }) => {
  return (
    <span className={cn("block w-10 h-10 text-gray-500 ", className)}>
      <svg
        width={"100%"}
        height={"100%"}
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 6.24002C13 9.40994 10.3133 11.98 7 11.98C6.61042 11.9806 6.22192 11.9445 5.83924 11.8727C5.5638 11.8209 5.42607 11.7951 5.32992 11.8098C5.23376 11.8245 5.09751 11.8969 4.82499 12.0418C4.05408 12.4518 3.15517 12.5966 2.29067 12.4358C2.61924 12.0316 2.84365 11.5467 2.94267 11.0269C3.00267 10.7089 2.854 10.4 2.63133 10.1739C1.62 9.1469 1 7.76306 1 6.24002C1 3.07014 3.68667 0.5 7 0.5C10.3133 0.5 13 3.07014 13 6.24002Z"
          stroke="currentColor"
          strokeLinejoin="round"
        />
        <path
          d="M6.99886 6.5H7.00426M9.39616 6.5H9.40156M4.60156 6.5H4.60694"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default MessageRoundedIcon;
